import React, { useState } from 'react';
import { useNavigate } from "react-router-dom"; // Import useNavigate
import './AddMedicine.css';
import TimeSelector from "../../Components/TimeSelector/TimeSelector";
import backIcon from "../../Assets/Images/Expand_left.png";
import SearchIcon from "../../Assets/Images/SVG/Search.svg";
import DropdownIcon from "../../Assets/Images/SVG/Dropdown.svg";
import MorningIcon from "../../Assets/Images/SVG/SunriseGrey.svg";
import AfternoonIcon from "../../Assets/Images/SVG/SunGrey.svg";
import EveningIcon from "../../Assets/Images/SVG/CloudGrey.svg";
import NightIcon from "../../Assets/Images/SVG/MoonGrey.svg";
import AlarmIcon from "../../Assets/Images/SVG/AlarmGrey.svg";
import CalendarIcon from "../../Assets/Images/SVG/Mytest-Calendar.svg";
import decrements from "../../Assets/Images/decrement.png";
import increments from "../../Assets/Images/increment.png";

const AddMedicine = () => {
    const navigate = useNavigate();
    const [testName, setTestName] = useState("");
    const [instruction, setInstruction] = useState("");
    const [otherInstruction, setOtherInstruction] = useState("");
    const [selectedTimes, setSelectedTimes] = useState([]);
    const [duration, setDuration] = useState("Daily");
    const [startDate, setStartDate] = useState("");
    const [lastDate, setLastDate] = useState("");
    const [numberOfDays, setNumberOfDays] = useState("");
    const [currentLabel, setCurrentLabel] = useState("");
    const [showTimeSelector, setShowTimeSelector] = useState(false);
    const [customTimes, setCustomTimes] = useState({
        Morning: "09:30 AM",
        Afternoon: "12:30 PM",
        Evening: "05:30 PM",
        Night: "09:30 PM",
      });

    // Initialize state with counters for each time label
    const [counters, setCounters] = useState({
        Morning: 0,
        Afternoon: 0,
        Evening: 0,
        Night: 0,
    });
    const handleTimeSelect = (time) => {
        if (selectedTimes.includes(time)) {
            setSelectedTimes(selectedTimes.filter((t) => t !== time));
        } else {
            setSelectedTimes([...selectedTimes, time]);
        }
    };

    const handleDurationToggle = (selected) => {
        setDuration(selected);
    };

    const increment = (label) => {
        setCounters((prevCounters) => ({
            ...prevCounters,
            [label]: prevCounters[label] + 1,
        }));
    };

    const decrement = (label) => {
        setCounters((prevCounters) => ({
            ...prevCounters,
            [label]: Math.max(0, prevCounters[label] - 1),
        }));
    };

    const [dosageType, setDosageType] = useState('');
  const [dosage, setDosage] = useState('');

  const handleDosageTypeChange = (e) => {
    setDosageType(e.target.value);
  };

  const handleDosageChange = (e) => {
    setDosage(e.target.value);
  };
  const handleTimeSet = (hour, minute, period) => {
    const formattedTime = `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${period}`;
    setCustomTimes((prevTimes) => ({ ...prevTimes, [currentLabel]: formattedTime }));
    setShowTimeSelector(false);
  };

  const openTimeSelector = (label) => {
    setCurrentLabel(label);
    setShowTimeSelector(true);
  };

    return (
        <div className="add-mytest-container">
            <div className="addtest-header">
                <button className="back-button" onClick={() => navigate('/mymedicine')}>
                    <img src={backIcon} alt="Back" className="back-icon" />
                </button>
                <h1>Add Medicine</h1>
            </div>

            <div className="add-test-container">
                {/* Test Name Input */}
                <div className="form-group">
                    <label>
                        Medicine Name<span>*</span>
                    </label>
                    <div className="select-input">
                        <input
                            type="text"
                            placeholder="Select"
                            value={testName}
                            onChange={(e) => setTestName(e.target.value)}
                            style={{ fontFamily: "Avenir LT STD" }}
                        />
                        <img src={SearchIcon} alt="search icon" className="search-icon" />
                        <img src={DropdownIcon} alt="dropdown icon" className="dropdown-icon" />
                    </div>
                </div>

                <div className="dosage-container">
      {/* Dosage Type Field */}
      <div className="form-group">
        <label htmlFor="dosage-type">Dosage Type<span>*</span></label>
        <div className="select-input">
          <select
            id="dosage-type"
            value={dosageType}
            onChange={handleDosageTypeChange}
          >
            <option value="" disabled selected>Select</option>
            <option value="tablet">Tablet</option>
            <option value="capsule">Capsule</option>
            <option value="syrup">Syrup</option>
          </select>
        </div>
      </div>

      {/* Dosage Field */}
      <div className="form-group">
        <label htmlFor="dosage">Dosage<span>*</span></label>
        <div className="select-input">
          <select
            id="dosage"
            value={dosage}
            onChange={handleDosageChange}
          >
            <option value="" disabled selected>Select</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
          </select>
        </div>
      </div>
    </div>

                {/* Instructions Radio Group */}
                <div className="form-group">
                    <label>
                        Instructions<span>*</span>
                    </label>
                    <div className="radio-group">
                        {["Before Food", "After Food", "Others"].map((option) => (
                            <label key={option} className="radio-option">
                                <input
                                    type="radio"
                                    name="instruction"
                                    value={option}
                                    checked={instruction === option}
                                    onChange={() => setInstruction(option)}
                                />
                                {option}
                            </label>
                        ))}
                    </div>

                    {/* Conditionally render input box when "Others" is selected */}
                    {instruction === "Others" && (
                        <input
                            type="text"
                            placeholder="Enter your instructions here"
                            value={otherInstruction}
                            onChange={(e) => setOtherInstruction(e.target.value)}
                            className="other-instruction-input"
                        />
                    )}
                </div>

                {/* Time Options */}
                <div className="time-options">
                    {[
                        { label: "Morning", time: "09:30 AM", icon: MorningIcon },
                        { label: "Afternoon", time: "12:30 PM", icon: AfternoonIcon },
                        { label: "Evening", time: "05:30 PM", icon: EveningIcon },
                        { label: "Night", time: "09:30 PM", icon: NightIcon },
                    ].map(({ label, time, icon }) => (
                        <div
                            key={label}
                            className={`time-card ${selectedTimes.includes(label) ? "selected" : ""}`}
                        >
                            <div className="time-label">
                                <input
                                    type="checkbox"
                                    id={label}
                                    checked={selectedTimes.includes(label)}
                                    onChange={() => handleTimeSelect(label)}
                                />
                                <span>{label}</span>
                            </div>
                            <div className="time-icon">
                                <img src={icon} alt={`${label} icon`} />
                            </div>
                            <div className="counter-controls">
                                <button onClick={() => decrement(label)} className="button">
                                    <img src={decrements} alt="Decrement" className="icon-images" />
                                </button>
                                <div className="counter">{counters[label]}</div>
                                <button onClick={() => increment(label)} className="button">
                                    <img src={increments} alt="Increment" className="icon-images" />
                                </button>
                            </div>
                            <div className="time-details">
                                {/* Open popup on clicking the alarm icon */}
                                <img
                                    src={AlarmIcon}
                                    alt="alarm icon"
                                    className={`alarm-icon ${selectedTimes.includes(label) ? "selected" : ""}`}
                                    onClick={() => openTimeSelector(label)}
                                />
                                <span className="time">{time}</span>
                            </div>
                        </div>
                    ))}
                </div>

                  {/* Display Selected Times as Reminders */}
        <div className="reminder-display">
          {selectedTimes.map((time) => (
            <div key={time} className="reminder-text">
              {`${time} Reminder ${customTimes[time]}`}
            </div>
          ))}
        </div>

        {/* TimeSelector Popup */}
        {showTimeSelector && (
          <div className="time-selector-overlay">
            <TimeSelector onTimeSet={handleTimeSet} onCancel={() => setShowTimeSelector(false)} />
          </div>
        )}


                {/* Duration Toggle */}
                <div className="duration-group">
                    <label>Duration</label>
                    <div className="duration-toggle">
                        <span
                            className={`duration-option ${duration === "Daily" ? "active" : ""}`}
                            onClick={() => handleDurationToggle("Daily")}
                        >
                            Daily
                        </span>
                        <span
                            className={`duration-option ${duration === "Custom" ? "active" : ""}`}
                            onClick={() => handleDurationToggle("Custom")}
                        >
                            Custom
                        </span>
                    </div>
                </div>

                {duration === "Custom" && (
                    <div className="custom-duration-container">
                        {/* Custom Date Inputs */}
                        <div className="custom-column">
                            <div className="input-row">
                                <label>
                                    Start Date<span>*</span>
                                </label>
                                <div className="select-input">
                                    <input
                                        type="text"
                                        placeholder="Select Date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        className="custom-input"
                                    />
                                    <img src={CalendarIcon} alt="calendar icon" className="calendar-icon" />
                                </div>
                            </div>

                            <div className="input-row">
                                <label style={{ fontSize: "14px" }}>Last Date</label>
                                <input
                                    type="text"
                                    placeholder="Last Date"
                                    className="custom-input"
                                    value={lastDate}
                                    onChange={(e) => setLastDate(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Number of Days Input */}
                        <div className="custom-column">
                            <div className="input-row">
                                <label style={{ fontSize: "14px" }}>Number of Days</label>
                                <input
                                    type="number"
                                    placeholder="00"
                                    value={numberOfDays}
                                    onChange={(e) => setNumberOfDays(e.target.value)}
                                    className="ncustom-input"
                                />
                                <span className="days-text">Days</span>
                            </div>
                        </div>
                    </div>
                )}

                {/* Action Buttons */}
                <div className="action-buttons">
                    <button className="test-cancel-btn">Cancel</button>
                    <button className="test-save-btn" onClick={() => navigate('/mymedicine-success')} >Save</button>
                </div>
            </div>
        </div>
    );
};

export default AddMedicine;
